/**
 * 
 * @param {*} center 
 * @param {*} radiusInKm 
 * @param {*} points 
 * @returns 
 */
export function geoPolygon(center, radiusInKm, points) {
  if (!points) points = 24
  var coords = {
    latitude: center[1],
    longitude: center[0]
  }
  var km = radiusInKm
  var ret = []
  var distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180))
  var distanceY = km / 110.574
  var theta, x, y
  for (var i = 0; i < points; i++) {
    theta = (i / points) * (2 * Math.PI)
    x = distanceX * Math.cos(theta)
    y = distanceY * Math.sin(theta)
    ret.push([coords.longitude + x, coords.latitude + y])
  }
  ret.push(ret[0])
  return {
    id: undefined,
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [ret]
    }
  }
} //geoPolygon


/**--------------------------------------------------------------------------
 * 【工具方法】生成geojson四边形（通常指非正方形，若要生成正方形请使用geoPolygon方法）
 * @param {Array} center 中心点经纬度坐标数组
 * @param {Number} radiusInKm 半径值，单位是km
 * @param {Number} points 点数，这个点数不会全描出来，而是要参考w参数，总共描出4个点
 * @param {Number} w 长边所占点数，如点数16，那么长宽相加共可用8，可设置长边占5~7，剩下的为短边，设置为4则是正方形
 */
export function geoRect(center, radiusInKm, points, w, skip) {
  if (!points) points = 16
  if (!skip) skip = 0
  const h = points / 2 - w
  const rect = [skip, skip + w, skip + w + h, skip + w + h + w]
  var coords = {
    latitude: center[1],
    longitude: center[0]
  }
  var km = radiusInKm
  var ret = []
  var distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180))
  var distanceY = km / 110.574
  var theta, x, y
  for (var i = 0; i < rect.length; i++) {
    theta = (rect[i] / points) * (2 * Math.PI)
    x = distanceX * Math.cos(theta)
    y = distanceY * Math.sin(theta)
    ret.push([coords.longitude + x, coords.latitude + y])
  }
  ret.push(ret[0])
  return {
    id: undefined,
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [ret]
    }
  }
} //geoRect



// WEBPACK FOOTER //
// ./src/common/MapTool.js